import { useState } from "react";
import Cookies from "js-cookie";
import AuthenticationContext from "./AuthenticationContext.ts";
import { useEffect, useContext } from "react";
import { USER_TYPE } from "constants/constants.js";
import toast from "react-hot-toast";
import AuthContext from "Authentication/AuthenticationContext.ts";
import logo from "assets/images/sitelogo.svg";
import toastFunction from "utils/toast";

import sendRequest from "hooks/useAxios";
// admin access level: [5, 7, 8, 9, 10, 11, 12]
// customer access level : [13,14,15,16]
interface UserInformation {
  token: string;
  fullName: string;
  userType: number;
  mobile: number;
  userName: string;
  accessLevel: number[];
  id: any;
  isFirst: boolean;
}
export default function Authentication({
  children,
}: {
  children: JSX.Element;
}) {
  const auth = useContext(AuthContext);

  const [userInfo, setUserInfo] = useState<UserInformation>({
    token: "",
    fullName: "",
    userType: -1,
    mobile: 0,
    userName: "",
    accessLevel: [],
    id: null,
    isFirst: true,
    bussinesses: [],
    url: "",
  });

  const [isLogged, setIsLogged] = useState<boolean>(false);
  const [checkLoginUpdater, setCheckLoginUpdater] = useState(false);

  useEffect(() => {
    checkCookie();
  }, [checkLoginUpdater]);

  function login(
    token: string,
    fullName: string,
    userType: number,
    mobile: number,
    userName: string,
    accessLevel: any[],
    id: any,
    bussinesses: [],
    url: string
  ): void {
    if (token) {
      // if (userType == 1) {
      //   accessLevel = [13, 14, 15, 16];
      // }
      setUserInfo({
        token,
        fullName,
        userType: userType,
        mobile,
        userName,
        accessLevel,
        id: id,
        bussinesses,
        url,
        isFirst: false,
      });

      setIsLogged(true);
      Cookies.set("token", token, { expires: 7 });
    }
  }

  function logout(): void {
    setUserInfo({
      token: "",
      fullName: "",
      userType: -1,
      mobile: 0,
      userName: "",
      accessLevel: [],
      id: null,
      isFirst: false,
      bussinesses: [],
      url: "",
    });
    setIsLogged(false);
    Cookies.remove("token");
  }

  function checkCookie(): void {
    if (Cookies.get("token")) {
      sendRequest("checklogininfo", {}).then(({ data }) => {
        if (data.status == -1) {
          toastFunction("error", "کاربری با این مشخصات یافت نشد.");

          Cookies.remove("token");

          return "";
        }

        // let userType;
        // if (value.userinfo[0].isadmin == 1) {
        //   switch (+value.userinfo[0].user_admin_group) {
        //     case 1:
        //       userType = USER_TYPE.generalAdmin;
        //       break;
        //     case 2:
        //       userType = USER_TYPE.tourLeader;
        //       break;
        //     case 3:
        //       userType = USER_TYPE.accountants;
        //       break;
        //     case 4:
        //       userType = USER_TYPE.saleCounter;
        //       break;
        //     default:
        //       break;
        //   }
        // } else {
        //   userType = USER_TYPE.customer;
        // }
        let userType;
        login(
          data.data.usertoken,
          data.userinfo[0].fname + " " + data.userinfo[0].lname,
          +data.userinfo[0].type,
          data.userinfo[0].mobile,
          "",
          [],
          +data.userinfo[0].id,
          data.bussinesses,
          data.userinfo[0].url
        );
      });
    } else {
      setUserInfo({
        token: "",
        fullName: "",
        userType: -1,
        mobile: 0,
        userName: "",
        accessLevel: [],
        id: null,
        isFirst: false,
        bussinesses: [],
      });
    }
  }
  const loginUpdater = () => {
    setCheckLoginUpdater((prev) => !prev);
  };
  return (
    <>
      <AuthenticationContext.Provider
        value={{
          login,
          userInfo,
          isLogged,
          logout,
          loginUpdater,
        }}
      >
        {children}
      </AuthenticationContext.Provider>
    </>
  );
}
